<style lang="stylus" scoped>
.header {
  display: flex;
  justify-content: space-between;
}

.mark {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  background: rgba(0, 0, 0, 0.7);
  z-index: 100;

  .circle {
    margin: auto;
  }
}

.carWrap {
  padding: 20px;
  background: #fff;
  border-radius: 10px;

  main {
    flex: 1;
  }
}
</style>
<template>
  <div>
  <div style class="carWrap">
    <dimension-dialog
      v-if="showExport"
      @hideExport="hideExport1"
      :provinceName="formData.provinceName||provinceName"
      :provinCode="getCurProvinceCode()"
      :cityName="cityName"
      :moduleName="moduleName"
      :autoChunkMonth="true"
      :dateSeparator="''"
    />
    <!--<div class="mark" v-if="mark">
      <el-progress type="circle" :percentage="progressNum" class="circle" style="color:#fff;"></el-progress>
    </div>-->
    <div class="header">
      <el-form :inline="true" :model="formData" label-width="90px">
        <!--el-form-item label="统计月份：">
          <el-date-picker
            v-model="monTime"
            type="month"
            placeholder="选择月"
            @change="changeTime"
            value-format="yyyy-MM"
            style="width: 120px;"
          ></el-date-picker>
        </el-form-item-->
        <el-form-item label="统计月份：">
          <dimension-popover :autoChunkMonth="true" :isMapValue="true" :dimObj="dimObj" :change="changeDimension" :showBottomButton="false" :isItemBindClick="true" />
        </el-form-item>
        <el-form-item label="省份：" label-width="60px">
          <el-select v-model="formData.provinceName" placeholder="请选择活动区域" @change="getCityList" style="width: 150px;" >
            <el-option
              v-for="(item,index) in areaList"
              :label="item.provinceName"
              :value="item.provinceName"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <!--el-form-item label="地区：" label-width="100px">
          <el-select v-model="formData.cityName" placeholder="请选择活动区域" @change="getCityName" style="width: 150px;">
            <el-option label="全部" value></el-option>
            <el-option
              v-for="(item,index) in cityData"
              :label="item.cityName"
              :value="item.cityName"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item-->
        <!--el-form-item label="旗下车辆数" label-width="100px">
          <el-input v-model.trim.number="formData.vehiclesNumber" placeholder="请输入" style="width: 150px;"></el-input>
        </el-form-item-->
      </el-form>
      <div style="float:right;">
        <el-button @click="submitData">查询</el-button>
        <el-button @click="goback">返回上一级</el-button>
        <el-button v-show="hideExport" @click="exportDate">导出</el-button>
      </div>
    </div>
    <main>
      <Table :allData="allData" :index="indexAll"/>
    </main>
    <!--div class="block" style="width: fit-content; margin-left: auto; margin-right: auto;">
      <el-pagination
        @current-change="changeData"
        :current-page.sync="index"
        :page-size="pageSize"
        layout="prev, pager, next, jumper"
        :total="total"
        slot="pagin"
      ></el-pagination>
    </div-->
  </div>
  <div class="bottom-top">
    <h4>
      <img src="../../../../../assets/images/title.png">
      <span>说明</span>
    </h4>
    <div>1.统计逻辑：统计不同燃料类型车辆在该运营省内各类型道路分品牌加能站停靠次数。</div>
    <div>2.停靠车次：不同燃料类型车辆在不同品牌加能站停靠次数汇总。【注】一辆车在同个加能站一天停靠多次计为一次；停靠统计时长范围为3分钟-2小时。</div>
    <div>3.统计频率：按月统计，每月6日更新上月数据。</div>
  </div>
  </div>
</template>
<script>
import Table from './components/table' // 表格数据
import Cookies from 'js-cookie'
import http from '@/api/freight.js' //请求汇总
//import exportDate from '@/components/exportDate'
//import exportDate from '@/components/exportDate/daphne/dialog.vue'
import { hideExport } from '@/utils/tools'
import dimensionPopover from '@/components/exportDate/daphne/popover.vue'
import dimensionDialog from '@/components/exportDate/daphne/dialog.vue'
import get from "lodash/get"
import find from "lodash/find"
export default {
  components: {
    Table,
    dimensionDialog,
    dimensionPopover,
  },
  props: {
    /*monTime: {
      type: String
    },*/
    /*endMonth: {
      type: String
    },*/
    provinceName: {
      type: String
    },
    provinceCode: {
      type: String
    },
    dimObj: {
      default: () => {
        return {
          year: "2022",
          month: "02",
          type: "0",
        }
      },
      type: Object
    },
  },
  data() {
    let endMonth = this.dimObj.year+this.dimObj.month;
    return {
      hideExport:hideExport,
      moduleName: 'wayRoadTypeTab2Detail',
      showExport: false, //控制批量导出
      formData: {
        provinceName:"",
      },
      cityName: '',
      areaList: [],
      cityData: [],
      // mark: false, // 遮罩层
      // progressNum: 0, // 导出下载进度条
      total: 0, // 总页数
      allData: [], // 总数据
      index: 1, // 当前页数
      endMonth, //请求日期
      pageSize: 20,
      indexAll: 0
    }
  },
  mounted() {
    //let that = this
    //let time = that.monTime
    //let year = time.getFullYear()
    //let month = time.getMonth()
    //that.endMonth = year + that.initMonth(month)
    this.formData.provinceName = this.provinceName;
    this.initData()
    this.getProvinces()
  },
  methods: {
    getProvinces() {
      let that = this
      http.getProvinces().then(e => {
        that.areaList = [...e.data]
        if(that.areaList.length==1){
          that.formData.provinceName = that.areaList[0].provinceName
          that.getCityList(that.areaList[0].provinceName)
        }
      })
    },
    getCityList(e) {
      /*if (e) {
        let that = this
        http.getCityList({ provname: e }).then(e => {
          that.cityData = [...e.data]
        })
      } else {
        this.provinceName = ''
        this.cityData = []
      }*/
    },
    getCityName(e) {
      this.cityName = e
    },
    // 取消导出
    hideExport1() {
      this.showExport = false
    },
    changeData(index) {
      let that = this
      that.index = index
      this.initData(1)
      that.indexAll = that.pageSize * (that.index - 1)
    },
    submitData() {
      this.index = 1
      this.indexAll = 0
      this.initData(1)
    },
    getCurProvinceCode(){
      let provinceCode = this.provinceCode;
      if(this.formData.provinceName){
        let obj = find(this.areaList,["provinceName",this.formData.provinceName]);
        if(obj){
          provinceCode=obj.provinceCode;
        }
      }else{
          provinceCode="all";
      }
      return provinceCode;
    },
    initData(num = 0) {
      let that = this
      let provinceCode = this.getCurProvinceCode();
      let dimObj = this.dimObj;
      let param={
        range:""+this.dimObj.year+this.dimObj.month,//"202006",
        dateType:""+this.dimObj.type,//"0",
        provinceCode,//"11"
      };
      http
        .carProvinceMileageV2_getGasStationStat_stopInfoByRoad(param)
        .then(e => {
          /*if (e.data && e.data.tPageUtil && e.data.tPageUtil.list) {
            that.allData = [...e.data.tPageUtil.list]
            //that.total = e.data.tPageUtil.count
            //that.monTime = e.data.time
            //that.endMonth = e.data.time.replace('-', '')
          }*/
          that.allData = get(e,"data",[]);
        })
    },
    changeDimension(e){
      if(e.isOk){
        this.endMonth = e.year+e.month;
        this.dimObj.year = e.year;
        this.dimObj.month = e.month;
        this.dimObj.type = e.type;
        this.changeTime();
      }
    },
    changeTime() {
      /*let that = this
      let time = that.monTime
      let arr = time.split('-')
      that.endMonth = arr[0] + '' + arr[1]*/
    },
    initMonth(num) {
      let newNum = num + 1
      return newNum < 10 ? '0' + newNum : newNum + ''
    },
    exportDate() {
      this.showExport = true
      return
    },
    goback(){
      this.$emit("closeDetails")
    },
  }
}
</script>
